import { render, staticRenderFns } from "./handleScroll.vue?vue&type=template&id=15137061&"
import script from "./handleScroll.vue?vue&type=script&lang=js&"
export * from "./handleScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports